import { Link } from "react-router-dom";
import {
  HelpCircle,
  BookOpen,
  PanelLeft,
  Star,
} from "lucide-react";
import { BrandSwitcher, type BrandOption } from "./BrandSwitcher";
import { UserMenu, type OrgOption } from "./UserMenu";
import { ThemeToggle } from "./ThemeToggle";

export function AppTopBar({
  user,
  orgs,
  activeOrgId,
  brands,
  activeBrandId,
  onBrandChange,
  onToggleSidebar,
  isOwner,
}: {
  user: { email: string; name: string | null };
  orgs: OrgOption[];
  activeOrgId: string;
  brands: BrandOption[];
  activeBrandId: string;
  onBrandChange: (id: string) => void;
  onToggleSidebar: () => void;
  isOwner: boolean;
}) {
  return (
    <header className="sticky top-0 z-20 flex h-14 items-center gap-2 border-b border-slate-200 bg-white px-3 dark:border-slate-800 dark:bg-slate-900 sm:gap-3 sm:px-4">
      <Link
        to="/"
        className="flex items-center gap-1.5 font-semibold tracking-tight text-slate-900 dark:text-slate-100"
      >
        <span aria-hidden className="hidden items-center gap-0.5 sm:flex">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star
              key={i}
              className="h-2.5 w-2.5 fill-emerald-500 text-emerald-500"
            />
          ))}
        </span>
        Reputely
      </Link>

      <button
        type="button"
        onClick={onToggleSidebar}
        className="hidden rounded-md p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200 md:inline-flex"
        aria-label="Toggle sidebar"
      >
        <PanelLeft className="h-4 w-4" />
      </button>

      <div className="h-6 w-px bg-slate-200 dark:bg-slate-800" />

      {brands.length > 0 && (
        <BrandSwitcher
          value={activeBrandId}
          onChange={onBrandChange}
          brands={brands}
          canManage={isOwner}
        />
      )}

      <div className="ml-auto flex items-center gap-1.5">
        <div className="hidden items-center gap-1.5 sm:flex">
          <a
            href="https://reputely.co/faq"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 rounded-md p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
            aria-label="Help"
          >
            <HelpCircle className="h-4 w-4" />
          </a>
          <a
            href="https://reputely.co/how-it-works"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 rounded-md p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-200"
            aria-label="Docs"
          >
            <BookOpen className="h-4 w-4" />
          </a>
          <ThemeToggle />
        </div>
        <div className="ml-1">
          <UserMenu user={user} orgs={orgs} activeOrgId={activeOrgId} />
        </div>
      </div>
    </header>
  );
}
